import { render } from "./auth.vue?vue&type=template&id=a6ff5c76&scoped=true&ts=true"
import script from "./auth.vue?vue&type=script&lang=ts"
export * from "./auth.vue?vue&type=script&lang=ts"

import "./auth.vue?vue&type=style&index=0&id=a6ff5c76&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6ff5c76"]])

export default __exports__